import {
  Box,
  Button,
  Card,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import customerActions from "../../redux/customer/actions";
import PreferenceWiseTable from "../../common/PreferenceWiseTable";

export default function Index() {
  const dispatch = useDispatch();
  const [courseid, setCourseId] = useState(0);
  const [buttonClick, setButtonClick] = useState(false);
  const [courseError, setCourseError] = useState("");
  const [preference, setPreference] = useState(1);
  const [preferenceError, setPreferenceError] = useState("");
  const preferencesno = [
    { name: "Preference 1", value: 1 },
    { name: "Preference 2", value: 2 },
    { name: "Preference 3", value: 3 },
    { name: "Preference 4", value: 4 },
  ];

  const { courseList } = useSelector((state) => state.masterReducer);

  const { preferenceWiseReport } = useSelector(
    (state) => state.customerReducer
  );

  useEffect(() => {
    setCourseId(0);
    setPreference(1);
    localStorage.removeItem("preferencewisereport");
  }, []);

  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    const storedData = JSON.parse(localStorage.getItem("preferencewisereport"));
    if (storedData) {
      setCourseId(storedData.courseid);
    }
    dispatch({
      type: customerActions.GET_PREFERENCEWISE_REPORT,
      payload: {
        courseid: 0,
        preference: 0,
      },
    });

    return () => {};
  }, [dispatch]);

  const onChangeCourse = (e) => {
    setCourseId(e.target.value);
  };

  const onChangePreference = (event) => {
    setPreference(event.target.value);
    setPreference(event.target.value);
  };

  const handleGenerate = () => {
    setButtonClick(true);
    let hasError = false;

    if (courseid === 0) {
      setCourseError("Course is required");
      hasError = true;
    } else {
      setCourseError("");
    }

    if (!hasError) {
      const formData = {
        courseid: courseid,
        preference: preference,
      };
      localStorage.setItem("preferencewisereport", JSON.stringify(formData));

      if (courseid === -1) {
        dispatch({
          type: customerActions.GET_ALL_COURSES_PREFERENCEWISE_REPORT,
          payload: {
            courseid: courseid,
            preference: preference,
          },
        });
      } else {
        dispatch({
          type: customerActions.GET_PREFERENCEWISE_REPORT,
          payload: {
            courseid: courseid,
            preference: preference,
          },
        });
      }
    }
  };

  useEffect(() => {
    const removeLocalStorage = () => {
      localStorage.removeItem("preferencewisereport");
    };

    window.addEventListener("beforeunload", removeLocalStorage);

    return () => {
      window.removeEventListener("beforeunload", removeLocalStorage);
    };
  }, []);

  const applicationStatusColumns = [
    {
      name: "",
      colSpan: 2,
      subHeaders: [
        { name: "Preference", dataIndex: "preference" },
        { name: "City", dataIndex: "city" },
      ],
    },

    {
      name: "Overall",
      colSpan: 8,
      subHeaders: [
        { name: "Total", dataIndex: "overall_total" },
        { name: "Male", dataIndex: "overall_male" },
        { name: "Female", dataIndex: "overall_female" },
        { name: "Others", dataIndex: "overall_others" },
        { name: "Reserved Category", dataIndex: "overall_reserved_category" },
        { name: "Open", dataIndex: "overall_open" },
        { name: "PWD", dataIndex: "overall_pwd" },
        { name: "Non PWD", dataIndex: "overall_non_pwd" },
      ],
    },

    {
      name: "Male",
      colSpan: 5,
      subHeaders: [
        { name: "Total", dataIndex: "male_total" },
        { name: "Reserved Category", dataIndex: "male_reserved_category" },
        { name: "Open", dataIndex: "male_open" },
        { name: "PWD", dataIndex: "male_pwd" },
        { name: "Non PWD", dataIndex: "male_non_pwd" },
      ],
    },

    {
      name: "Female",
      colSpan: 5,
      subHeaders: [
        { name: "Total", dataIndex: "female_total" },
        { name: "Reserved Category", dataIndex: "female_reserved_category" },
        { name: "Open", dataIndex: "female_open" },
        { name: "PWD", dataIndex: "female_pwd" },
        { name: "Non PWD", dataIndex: "female_non_pwd" },
      ],
    },

    {
      name: "Other",
      colSpan: 5,
      subHeaders: [
        { name: "Total", dataIndex: "others_total" },
        { name: "Reserved Category", dataIndex: "others_reserved_category" },
        { name: "Open", dataIndex: "others_open" },
        { name: "PWD", dataIndex: "others_pwd" },
        { name: "Non PWD", dataIndex: "others_non_pwd" },
      ],
    },
    {
      name: "Grand Total",
      colSpan: 1,
      subHeaders: [{ name: "Total", dataIndex: "grand_total" }],
    },
  ];

  const applicationStatusData = Array.isArray(preferenceWiseReport)
    ? preferenceWiseReport.map((entry) => {
        const overall_total = Number(entry.overall_total ?? 0);
        const overall_male = Number(entry.overall_male ?? 0);
        const overall_female = Number(entry.overall_female ?? 0);
        const overall_others = Number(entry.overall_others ?? 0);

        return {
          preference: entry.preference_no ?? "NA",
          city: entry.preference_city ?? "NA",

          overall_total,
          overall_male,
          overall_female,
          overall_others,
          overall_reserved_category: Number(
            entry.overall_reserved_category ?? 0
          ),
          overall_open: Number(entry.overall_open ?? 0),
          overall_pwd: Number(entry.overall_pwd ?? 0),
          overall_non_pwd: Number(entry.overall_non_pwd ?? 0),

          male_total: Number(entry.overall_male ?? 0),
          male_reserved_category: Number(entry.male_reserved_category ?? 0),
          male_open: Number(entry.male_open ?? 0),
          male_pwd: Number(entry.male_pwd ?? 0),
          male_non_pwd: Number(entry.male_non_pwd ?? 0),

          female_total: Number(entry.overall_female ?? 0),
          female_reserved_category: Number(entry.female_reserved_category ?? 0),
          female_open: Number(entry.female_open ?? 0),
          female_pwd: Number(entry.female_pwd ?? 0),
          female_non_pwd: Number(entry.female_non_pwd ?? 0),

          others_total: Number(entry.overall_others ?? 0),
          others_reserved_category: Number(entry.others_reserved_category ?? 0),
          others_open: Number(entry.others_open ?? 0),
          others_pwd: Number(entry.others_pwd ?? 0),
          others_non_pwd: Number(entry.others_non_pwd ?? 0),
          grand_total: overall_total,
        };
      })
    : [];

  const safeTableData = courseid === 0 ? [] : applicationStatusData;

  const buildCsvHeaders = () => {
    const headerRow1 = [];
    const headerRow2 = [];

    applicationStatusColumns.forEach((col) => {
      if (col.subHeaders) {
        col.subHeaders.forEach((_, index) => {
          headerRow1.push(index === 0 ? col.name : "");
        });
        col.subHeaders.forEach((sub) => {
          headerRow2.push(sub.name);
        });
      } else {
        headerRow1.push(col.name);
        headerRow2.push("");
      }
    });

    return [headerRow1.join(","), headerRow2.join(",")];
  };

  const buildCsvRows = () =>
    applicationStatusData.map((row) =>
      applicationStatusColumns
        .flatMap((col) =>
          col.subHeaders
            ? col.subHeaders.map((sub) => row[sub.dataIndex] ?? "")
            : [row[col.dataIndex] ?? ""]
        )
        .join(",")
    );

  const buildTotalRow = () => {
    const totals = {};

    applicationStatusColumns.forEach((col) => {
      if (col.subHeaders) {
        col.subHeaders.forEach((sub) => {
          totals[sub.dataIndex] = applicationStatusData.reduce(
            (sum, r) => sum + Number(r[sub.dataIndex] || 0),
            0
          );
        });
      }
    });

    return applicationStatusColumns
      .flatMap((col) =>
        col.subHeaders
          ? col.subHeaders.map((sub) =>
              sub.dataIndex === "preference"
                ? "TOTAL"
                : sub.dataIndex === "city"
                ? ""
                : totals[sub.dataIndex]
            )
          : [""]
      )
      .join(",");
  };

  const downloadPreferenceWiseReport = () => {
    const headers = buildCsvHeaders();
    const rows = buildCsvRows();
    const totalRow = buildTotalRow();

    const csvContent = [...headers, ...rows, totalRow].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute(
      "download",
      `preference-wise-report-${courseid}-${Date.now()}.csv`
    );

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Box
        sx={{
          margin: "1rem auto",
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <Card sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography>Course Wise Preference Report</Typography>
          </Box>
          <Grid item sm={12}>
            <Box
              display="flex"
              justifyContent="space-between"
              sx={{ gap: 2, flexWrap: "wrap", mt: 2, alignItems: "center" }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                sx={{ gap: 2, flexWrap: "wrap", mt: 2 }}
              >
                <FormControl error={!!courseError} sx={{ width: "220px" }}>
                  <Select
                    size="small"
                    onChange={onChangeCourse}
                    value={courseid}
                    defaultValue={0}
                    sx={{ height: "56px" }}
                  >
                    <MenuItem value={0} selected>
                      Select Course <span style={{ color: "red" }}>*</span>
                    </MenuItem>
                    <MenuItem value={-1}>All</MenuItem>
                    {courseList?.all
                      ?.filter((course) => course.isactive === "1")
                      .map((course, i) => (
                        <MenuItem key={i} value={course.courseid}>
                          {course.coursename}
                        </MenuItem>
                      ))}
                  </Select>
                  {courseError && (
                    <Typography variant="caption" color="error">
                      {courseError}
                    </Typography>
                  )}
                </FormControl>

                {/* select preference  */}
                <FormControl sx={{ width: "220px", marginLeft: 2 }}>
                  <Select
                    size="small"
                    value={preference}
                    onChange={onChangePreference}
                    sx={{ height: "56px" }}
                  >
                    <MenuItem value="" disabled>
                      Select Preference
                    </MenuItem>
                    {preferencesno.map((pref) => (
                      <MenuItem key={pref.value} value={pref.value}>
                        {pref.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ marginTop: 1, display: "flex", gap: 2 }}>
                <BluePrimaryButton
                  title={"Generate"}
                  handleSubmit={handleGenerate}
                />
                <Button
                  variant="contained"
                  color="success"
                  onClick={downloadPreferenceWiseReport}
                  sx={{ height: "40px" }}
                >
                  Export To CSV
                </Button>
              </Box>
            </Box>
          </Grid>

          <Box sx={{ marginTop: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "500",
                color: "black",
                fontSize: "20px",
                lineHeight: "24px",
                mb: 2,
                backgroundColor: "whitesmoke",
                padding: "8px",
                borderRadius: "4px",
              }}
            >
              Course Wise Preference Report{" "}
            </Typography>
          </Box>
          <PreferenceWiseTable
            columnData={applicationStatusColumns}
            tableData={safeTableData}
          />
        </Card>
      </Box>
    </>
  );
}
